// get redeem
export const GET_REDEEM = "GET_REDEEM";

// accepted redeem
export const ACCEPT_REDEEM = "ACCEPT_REDEEM";

// admin redeem
export const CREATE_ADMIN_REDEEM = "CREATE_ADMIN_REDEEM";
export const GET_ADMIN_REDEEM = "GET_ADMIN_REDEEM";
